<script setup>
import {computed, ref, onMounted, watch, nextTick} from "vue";
import { useStore } from "vuex";

const props = defineProps({
	list: {
		type: Array,
		default: () => []
	},
	
	modelValue: {
		type: Number,
		default: 0
	}
})

const emits = defineEmits(['update:modelValue'])

const store = useStore()

const currentLang = computed(() => store.getters.currentLanguage)

const sliderStyle = computed(() => {
	if (!tabRefs.value[currentIndex.value]) return {};
	const tabRect = tabRefs.value[currentIndex.value].getBoundingClientRect();
	const containerRect = tabsContainer.value.getBoundingClientRect();
	const left = tabRect.left - containerRect.left;
	const width = tabRect.width;
	return {
		left: `${left}px`,
		width: `${width}px`
	};
});

const tabRefs = ref([])
const tabsContainer = ref(null)
// const currentIndex = ref(0)
const sliderStyles = ref(null)

const currentIndex = computed(() => {
	const index = props.list.findIndex(item => item.value === props.modelValue)
	
	return index === -1 ? 0 : index
})

const selectTab = (id, index) => {
	emits('update:modelValue', id)
	nextTick(() => {
		updateSliderStyle()
	})
}

const updateSliderStyle = () => {
	if (!tabRefs.value[currentIndex.value]) return {};
	const tabRect = tabRefs.value[currentIndex.value].getBoundingClientRect();
	const containerRect = tabsContainer.value.getBoundingClientRect();
	const left = tabRect.left - containerRect.left;
	const width = tabRect.width;
	sliderStyles.value = {
		left: `${left}px`,
		width: `${width}px`
	}
}

const debounce = (func, wait) => {
	let timeout;
	return function(...args) {
		clearTimeout(timeout);
		timeout = setTimeout(() => func.apply(this, args), wait);
	};
};

const debouncedUpdateSliderPosition = debounce(updateSliderStyle, 150);

const scrollLeft = () => {
	tabsContainer.value.scrollLeft -= 100;
}

const scrollRight = () => {
	tabsContainer.value.scrollLeft += 100;
}

watch(
	() => currentLang.value,
	(n) => {
		nextTick(() => {
			updateSliderStyle()
		})
	}
)

onMounted(() => {
	updateSliderStyle()
	window.addEventListener('resize', debouncedUpdateSliderPosition)
})
</script>

<template>
	<div class="tab">
		<div class="tab__list" ref="tabsContainer">
			<div
				class="tab__item"
				v-for="(item, index) in list"
				:key="index"
				:class="{
					'tab__item--active': item.value === modelValue
				}"
				ref="tabRefs"
				@click="selectTab(item.value, index)"
			>
				{{ item.label }}
			</div>
		</div>
		
		<div
			class="tab__active__line"
			:style="sliderStyles ?? sliderStyle"
		/>
	</div>
</template>

<style scoped lang="less">
.tab {
	position: relative;
	//overflow: auto;
	//padding: 20px 0;
	
	&__list {
		display: flex;
		justify-content: space-between;
		border-bottom: 2px solid #DCDFE6;
	}
	
	&__item {
		text-align: center;
		padding: 32px 40px;
		font-size: 24px;
		color: #909399;
		cursor: pointer;
		// white-space: nowrap;
		word-wrap: break-word;
		word-break: break-word;
		
		&:hover {
			color: @primary-color;
		}
		
		&--active {
			font-weight: bold;
			color: @primary-color;
		}
	}
	
	&__active__line {
		position: absolute;
		bottom: 0px;
		height: 2px;
		background-color: @primary-color;
		transition: left 0.3s ease, width 0.3s ease;
	}
	
	.scroll-button {
		width: 100%;
		position: absolute;
		top: 0;
		display: flex;
		justify-content: space-between;
	}
}

@media only screen and (max-width: 1024px) {
	.tab {
		
		&__item {
			text-align: center;
			padding: 20px;
			font-size: 18px;
			
			&:hover {
				color: @primary-color;
			}
			
			&--active {
				font-weight: bold;
				color: @primary-color;
			}
		}
	}
}
</style>